// extracted by mini-css-extract-plugin
module.exports = {"main":"tabs_main__gBTau","user":"tabs_user__u9X3U","atv":"tabs_atv__1ox43"};